export default "__VITE_ASSET__Eq8JMvwX__"